import {
    PORFILE_INITATED,
    PORFILE_LOADED,
    PORFILE_FAILED,
} from '../actions/ProfileAction.js';

const initialState = {
   profile: {}
};

const ProfileReducer = (state = initialState, action) => {
    switch(action.type) {
        case PORFILE_INITATED: 
            return {
                ...state,
                profile: {}
            };

        case PORFILE_LOADED: 
            return {
                ...state,
                profile: action.payload
            };

        case PORFILE_FAILED: 
            return {
                ...state,
                profile: {}
            };

        default:
            return state;
    }
};

export default ProfileReducer;
